// extracted by mini-css-extract-plugin
export default {"header":"header_header__A7NEZ","wrapper":"header_wrapper__didg0","mobileNav":"header_mobileNav__lspR+","logo":"header_logo__TmkQW","aboutHeader":"header_aboutHeader__WhZ3x"};